import React from 'react';
import { LureType, ArmatureSize, LureSize, AppState } from '../types';
interface Props {
  selectedLureColor?: string;
  onLureColorChange?: (color: string) => void;
  selectedLureSize?: LureSize;
  onLureSizeChange?: (size: LureSize) => void;
  selectedArmatureSize?: ArmatureSize;
  onArmatureSizeChange?: (size: ArmatureSize) => void;
  bobberStopDepth?: number;
  onBobberStopDepthChange?: (depth: number) => void;
  position?: 'top' | 'bottom';
  presets?: (AppState | null)[];
  activePreset?: number | null;
  onPresetPlay?: (index: number) => void;
  onPresetSave?: (index: number) => void;
}
export function LureSelector({
  selectedLureColor,
  onLureColorChange,
  selectedLureSize,
  onLureSizeChange,
  selectedArmatureSize,
  onArmatureSizeChange,
  bobberStopDepth = 6,
  onBobberStopDepthChange,
  position = 'bottom',
  presets,
  activePreset,
  onPresetPlay,
  onPresetSave
}: Props) {
  const LURE_SIZES: LureSize[] = ['XS', 'S', 'M', 'L', 'XL'];
  const ARMATURE_SIZES: ArmatureSize[] = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
  return <>
      <div className={`absolute left-1/2 -translate-x-1/2 z-30 bg-[rgba(13,18,32,0.85)] backdrop-blur-sm border border-[#00f0ff]/30 px-3 py-1.5 shadow-[0_0_8px_rgba(0,240,255,0.1)] font-mono ${position === 'top' ? 'top-0 border-t-0 rounded-b' : 'bottom-0 border-b-0 rounded-t'}`} data-id="element-386">
        {/* Save Preset Row */}
        {presets && onPresetSave && <div className="flex items-center gap-1 mb-1.5 pb-1.5 border-b border-[#00f0ff]/15" data-id="element-387">
            <span className="text-[8px] font-bold uppercase tracking-widest text-white/50 mr-0.5" data-id="element-388">
              Save
            </span>
            {presets.map((preset, i) => <button key={i} onClick={() => onPresetSave(i)} className={`w-5 h-5 rounded flex items-center justify-center text-[9px] font-bold font-mono transition-all active:scale-90 relative ${activePreset === i ? 'bg-[#00ff88] text-[#050b14] shadow-[0_0_6px_rgba(0,255,136,0.4)]' : preset ? 'bg-[#1a2a4a] text-[#00ff88] border border-[#00ff88]/30' : 'bg-[#1a2a4a] text-white/40 border border-white/10 hover:border-white/30'}`} data-id="element-389">
                {i + 1}
                {preset && activePreset !== i && <div className="absolute -top-0.5 -right-0.5 w-1 h-1 rounded-full bg-[#00ff88] shadow-[0_0_3px_rgba(0,255,136,0.6)]" data-id="element-390" />}
              </button>)}
          </div>}

        {/* Selection Row */}
        <div className="flex items-start gap-2.5" data-id="element-391">
          {/* Lure Size Selector */}
          {onLureSizeChange && <div className="flex flex-col items-center gap-0.5" data-id="element-392">
              <span className="text-[9px] font-bold text-white uppercase tracking-wider" data-id="element-393">
                Lure Size
              </span>
              <div className="flex items-center gap-1" data-id="element-394">
                {LURE_SIZES.map(size => {
              const isActive = selectedLureSize === size;
              return <button key={size} onClick={() => onLureSizeChange(size)} className={`px-1.5 py-1 text-[10px] uppercase font-bold transition-all rounded ${isActive ? 'text-white bg-[rgba(255,255,255,0.2)]' : 'text-white/50 hover:text-white/80'}`} data-id="element-395">
                      {size}
                    </button>;
            })}
              </div>
            </div>}

          <div className="w-px h-6 bg-[#00f0ff]/20 self-end" data-id="element-396" />

          {/* Armature Size Selector */}
          {onArmatureSizeChange && <div className="flex flex-col items-center gap-0.5" data-id="element-397">
              <span className="text-[9px] font-bold text-white uppercase tracking-wider" data-id="element-398">
                Armature Length
              </span>
              <div className="flex items-center gap-1" data-id="element-399">
                {ARMATURE_SIZES.map(size => {
              const isActive = selectedArmatureSize === size;
              return <button key={size} onClick={() => onArmatureSizeChange(size)} className={`px-1.5 py-1 text-[10px] uppercase font-bold transition-all rounded ${isActive ? 'text-white bg-[rgba(255,255,255,0.2)]' : 'text-white/50 hover:text-white/80'}`} data-id="element-400">
                      {size}
                    </button>;
            })}
              </div>
            </div>}
        </div>

        {/* Preset Play Row */}
        {presets && onPresetPlay && <div className="flex items-center gap-1.5 mt-1.5 pt-1.5 border-t border-[#00f0ff]/15" data-id="element-401">
            <span className="text-[8px] font-bold uppercase tracking-widest text-[#00f0ff]/50 mr-0.5" data-id="element-402">
              Play
            </span>
            {presets.map((preset, i) => <button key={i} disabled={!preset} onClick={() => onPresetPlay(i)} className={`w-5 h-5 rounded flex items-center justify-center text-[9px] font-bold font-mono transition-all active:scale-90 ${!preset ? 'bg-white/5 text-white/15 cursor-not-allowed' : activePreset === i ? 'bg-[#00ff88] text-[#050b14] shadow-[0_0_8px_rgba(0,255,136,0.4)]' : 'bg-[#1a2a4a] text-[#00ff88] border border-[#00ff88]/30 hover:bg-[#00ff88]/20'}`} data-id="element-403">
                {i + 1}
              </button>)}
          </div>}
      </div>
    </>;
}